import { ClassDecoratorGenericType } from '@@/common/ts';

export function CrudMeta(meta: ICrudMetaArgs) {
  return function <T extends ClassDecoratorGenericType>(constructor: T) {
    return class extends constructor {
      tableName = meta.tableName;
      modelName = meta.modelName;
    };
  };
}

interface ICrudMetaArgs {
  tableName: string;
  modelName: string;
}
